import request from 'tools/request'

export const getRolesList = async () => {
  const companyId = localStorage.getItem('companyId')
  const res = await request.get(`${process.env.REACT_APP_CARRIER_API_URL}roleresource/role/get`, {
    params: {
      companyId: companyId,
    },
  })
  return res?.data
}
